module.exports = __webpack_public_path__ + "img/39_004_011.0324d0e6.png";